import React, { useContext, useEffect, useRef, useState } from "react";
import ActionItemsList from "./components/ActionItemsList";
import { ACTION_TYPE, ACTIONABLE_ITEM_TYPE_STRING } from "./components/constants";
import { FilterDrawer } from "./components/FilterDrawer";
import { useQueryParams } from "../../../../hooks/useQueryParams";
import Svg, { SvgEnum } from "../../../ui library/components/svgs/standard/svg";
import { FilterListConfig } from "./components/FilterListConfig";
import parseFromQueryParamstoUIState from "../../../cm/Dashboard/FullPages/CaseList/CaseListList/components/Filters/utils/parseFromQueryParamsToUIState";
import { useFollowUpSwimLaneStore } from "./hooks/useFollowUpSwimLaneStore";
import {
  useLoaderData,
  useLocation,
  useNavigate,
  useRevalidator,
  useSearchParams,
} from "react-router-dom";
import Filters from "./components/Filters";
import StatusSelect from "./components/StatusSelect";
import { Button } from "@mui/material";
import Header from "./components/Header";
import AddActionItemModal from "./components/AddActionItemModal";
import FollowUpModalProvider, {
  FollowUpModalDispatchContext,
  FollowUpModalStateContext,
} from "./context/FollowUpModalContext";
import { REDIRECT_URLS } from "../../../../../globalConstants";
import Search from "./components/Search";
import { useDashboardRefreshStore } from "../modules/hooks/useDashboardRefreshStore";
import FollowUpModal from "../../../cm/Dashboard/FullPages/ClientDetail/FollowUps/FollowUpModal";

export default function FollowUpSwimlanes() {
  const { actionItems } = useLoaderData();
  /* TEMPORARY MODAL BEGIN - only until form navigation is ready. can remove later */
  const followUpModalState = useContext(FollowUpModalStateContext);
  const followUpModalDispatch = useContext(FollowUpModalDispatchContext);
  /* TEMPORARY MODAL BEGIN - only until form navigation is ready. can remove later */
  const { filters, updateFilter, bulkUpdateFilters } = useQueryParams();
  const [filteredActionItems, setFilteredActionItems] = useState(actionItems);
  const state = useFollowUpSwimLaneStore((state) => state);
  const [lawfirm, setLawFirm] = useState([]);
  const [client, setClient] = useState([]);
  const [provider, setProvider] = useState([]);
  const [manual, setManual] = useState([]);
  const [toggleFilterMenu, setToggleFilterMenu] = useState(false);
  const [toggleAddActionItems, setToggleAddActionItems] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const storageKey = "mcc-followup-filters";
  const [activeActionItem, setActiveActionItem] = useState(null);
  const [toggleResetFilterButton, setToggleResetFilterButton] = useState(false);

  const viewDropdownDefault = filters.get("status")
    ? filters.get("status")
    : "done";
  const viewDropdownOptionsList = [
    { value: "pending", label: "Priority" },
    { value: "done", label: "Completed" },
  ];

  useEffect(() => {
    setFilteredActionItems(actionItems);
    hideResetFiltersButton();
    if (scrollRef.current) {
      scrollToTop();
    }
    saveCurrentFiltersToLocalStorage();
  }, [actionItems]);

  useEffect(() => {
    let active = true;

    if (active) {
      let client = [];
      let provider = [];
      let lawfirm = [];
      let manual = [];
      filteredActionItems.forEach((item) => {
        if (parseInt(item.actionType) === ACTION_TYPE.MANUAL) {
          manual.push(item);
        }
        if (parseInt(item.actionType) === ACTION_TYPE.CLIENT_FOLLOW_UP) {
          client.push(item);
        }
        if (parseInt(item.actionType) === ACTION_TYPE.LAW_FIRM_FOLLOW_UP) {
          lawfirm.push(item);
        }
        if (parseInt(item.actionType) === ACTION_TYPE.PROVIDER_FOLLOW_UP) {
          provider.push(item);
        }
      });
      setClient(client);
      setLawFirm(lawfirm);
      setProvider(provider);
      setManual(manual);
    }

    return () => {
      active = false;
    };
  }, [filteredActionItems]);

  useEffect(() => {
    let active = true;
    if (active) {
      if (!state.filterUI) {
        let newUI = { ...FilterListConfig };

        let parsedUIObj = parseFromQueryParamstoUIState(filters, newUI);
        state.setFilterUI(parsedUIObj);
      }
    }
  }, [state.filterUI, filters]);

  const scrollRef = useRef(null);

  const scrollToTop = () => {
    scrollRef.current.scroll({
      top: 0,
    });
  };

  const saveCurrentFiltersToLocalStorage = () => {
    let urlString = location.pathname + location.search;
    localStorage.setItem(storageKey, urlString);
  };

  const getCount = (count) => {
    if (!count) return 0;
    return count.length;
  };
  const openAddActionItemModal = () => {
    setToggleAddActionItems(true);
  };
  const defaultParams = {
    status: "pending",
    limit: 1000,
  };
  const resetFilters = () => {
    navigate(REDIRECT_URLS.MCC);
    state.setFilterUI(null);
    let clearedFilters = [];
    for (let filt of filters) {
      if (!defaultParams[filt[0]]) {
        clearedFilters.push([filt[0], undefined]);
      } else {
        clearedFilters.push([filt[0], defaultParams[filt[0]]]);
      }
      bulkUpdateFilters(clearedFilters);
    }
  };

  const hideResetFiltersButton = () => {
    let checkIfAnyFiltersActive = false;
    state.filterUI &&
      Object.keys(state.filterUI).map((ui) => {
        if (state.filterUI[ui].activeChip.isActive) {
          checkIfAnyFiltersActive = true;
        }
      });
    if (checkIfAnyFiltersActive) {
      setToggleResetFilterButton(true);
    } else {
      setToggleResetFilterButton(false);
    }
  };

  return (
    <div>
      <div
        id="followups-swimlane"
        className={`bg-white rounded-[15px] w-full flex-1 overflow-auto px-4 relative flex flex-col ${
          toggleFilterMenu ? "" : " pt-4"
        }`}
      >
        <div>
          {toggleFilterMenu ? (
            <FilterDrawer
              toggleFilterMenu={toggleFilterMenu}
              setToggleFilterMenu={setToggleFilterMenu}
            >
              {state.filterUI && (
                <Filters
                  filters={filters}
                  updateFilter={updateFilter}
                  bulkUpdateFilters={bulkUpdateFilters}
                />
              )}
            </FilterDrawer>
          ) : (
            ""
          )}
        </div>
        <div id="followups-swimlane-header">
          <div className="text-3xl">
            <span className="text-3xl font-semibold">Action Items</span> -
            Priority
          </div>
          <div className="flex mt-6 items-left">
            <div className="w-1/2">
              <div className="flex gap-2">
                <div className="w-1/4">
                  <StatusSelect
                    defaultSelection={viewDropdownDefault}
                    optionsList={viewDropdownOptionsList}
                  />
                </div>
                <div className="w-1/4">
                  <button
                    className="w-full"
                    style={{
                      backgroundColor: "#fff",
                      display: "flex",
                      borderRadius: "35px",
                      border: "1px solid #4C2AC6",
                      padding: "5px 20px 5px 20px",
                      gap: "12px",
                      color: "#4C2AC6",
                      fontWeight: "500",
                      alignItems: "center",
                    }}
                    onClick={() => setToggleFilterMenu(!toggleFilterMenu)}
                  >
                    <Svg name={SvgEnum.HisFilters} color="#4C2AC6" />
                    Filters
                  </button>
                </div>
                <div className="w-2/4 flex">
                  {toggleResetFilterButton && (
                    <Button
                      className="text-[0.75rem] capitalize underline text-red-500 pl-2 py-2 pointer"
                      onClick={() => {
                        resetFilters();
                      }}
                    >
                      X Clear Filters
                    </Button>
                  )}
                  <Button
                    className="text-[0.75rem] capitalize underline text-purple-800 px-3 py-2 pointer"
                    onClick={() => {
                      setActiveActionItem(null);
                      setToggleAddActionItems(true);
                    }}
                  >
                    + Add Action Item
                  </Button>
                </div>
              </div>
            </div>

            <div className="w-1/2 content-right">
              <Search
                id={"search"}
                placeholder={"Search Action Items"}
                filters={filters}
                updateFilter={updateFilter}
                setChipActive={state.setChipActive}
                setActiveChipLabel={state.setActiveChipLabel}
              />
            </div>
          </div>
        </div>
        <div id="followups-swimlane-content" className="mt-10">
          <div className="flex">
            <Header title={"Client Follow Ups"} count={getCount(client)} />
            <Header title={"Provider Follow Ups"} count={getCount(provider)} />
            <Header title={"Law Firm Follow Ups"} count={getCount(lawfirm)} />
            <Header title={"Action Items"} count={getCount(manual)} />
          </div>
          <div className="flex overflow-auto" ref={scrollRef}>
            <ActionItemsList
              action_type={ACTION_TYPE.CLIENT_FOLLOW_UP}
              itemsList={client}
              openAddActionItemModal={openAddActionItemModal}
            />
            <ActionItemsList
              action_type={ACTION_TYPE.PROVIDER_FOLLOW_UP}
              itemsList={provider}
              openAddActionItemModal={openAddActionItemModal}
            />
            <ActionItemsList
              action_type={ACTION_TYPE.LAW_FIRM_FOLLOW_UP}
              itemsList={lawfirm}
              openAddActionItemModal={openAddActionItemModal}
            />
            <ActionItemsList
              action_type={ACTION_TYPE.MANUAL}
              itemsList={manual}
              setActiveActionItem={setActiveActionItem}
              openAddActionItemModal={openAddActionItemModal}
            />
          </div>
        </div>
      </div>
      {toggleAddActionItems && (
        <AddActionItemModal
          addOpen={toggleAddActionItems}
          setAddOpen={setToggleAddActionItems}
          activeActionItem={activeActionItem}
          setActiveActionItem={setActiveActionItem}
        />
      )}
      {/* TEMPORARY MODAL BEGIN - only until form navigation is ready. can remove later */}
      {followUpModalState.selectedFollowUp &&
        followUpModalState.selectedFollowUp.actionType && (
          <FollowUpModal
            divId={"Follow-Up-Modal-Event"}
            title={
              ACTIONABLE_ITEM_TYPE_STRING[
                followUpModalState.selectedFollowUp.actionType
              ]
            }
            actionType={followUpModalState.selectedFollowUp.actionType}
            state={followUpModalState}
            dispatch={followUpModalDispatch}
          />
        )}
      {/* TEMPORARY MODAL END - only until form navigation is ready. can remove later */}
      </div>
  );
}
